import React, { useState, useEffect, useRef, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { NotificationManager } from "react-notifications";
import getuserinformation from "../../apis/userTest/getuserinformation";
import bubble from "../basicInfoForm/images/blue_bubble_small.png";
import VidOn from "../Icons/vidon";
import VidOff from "../Icons/vidoff";
import MicOff from "../Icons/micoff";
import MicOn from "../Icons/micon";
import DefaultThumbnail from "../basicInfoForm/images/defaultvideo.svg";
import recruiter_header_logo from "../../components/basicInfoForm/images/logo_recruiter_header.png";
import HomeContactUsModal from "../../pages/home/homeHeader/homeContactUsModal/homeContactUs";
import userTestQuestionInfo from "../../apis/userTest/userTestQuestionInfo";
import TestLandingSkeleton from "../Skelton/TestLandingSkeleton";
import { toHoursAndMinutes } from "../../utilities/toHourMinuteSecond";
import Footer from "../adminFooter/Footer";
import ReadAloudIcon from "../Icons/readaloud";
import RepeatIcon from "../Icons/repeat";
import ChatIcon from "../Icons/chat";
import SentenceIcon from "../Icons/sentence";
import VocabularyIcon from "../Icons/vocabulary";
import WritingIcon from "../Icons/writing";
import createvetcandidatetest from "../../apis/vetmanagecandidatetest/vetmanagecandidatetest";
import getvetjdbyid from "../../apis/vettest/getvetjdbyid";
import "../vettest/vettest.css";
import { UserTypeContext } from "../../AppRoute";
import UnauthorizedAccess from "../../components/UnauthorizedAccess/UnauthorizedAccess";

const TestLandingPage = (props) => {
  const location = useLocation();
  
  const history = useNavigate();
  const { userType } = useContext(UserTypeContext);
  const userCameraStreamRef = useRef(null);
  const [volume, setvolume] = useState(null);
  const [isModelOpen, setIsModelOpen] = useState(false);

  const [isAiInterviewFlow, setIsAiInterviewFlow] = useState(location?.state?.isAIInterview || false);
  const [isVetFlow, setIsVetFlow] = useState(location?.state?.isVet || false);
  const [isRegularSkillTestFlow, setIsRegularSkillTestFlow] = useState(!(location?.state?.isAIInterview || false) && !(location?.state?.isVet || false));
  const [currentTestData, setCurrentTestData] = useState((location?.state?.isAIInterview || false) ? location?.state : location?.state?.test);

  const isMicOpen = true;
  const [isDataLoaded, setisDataLoaded] = useState(false);
  const [allTestId, setAllTestId] = useState([]);
  const videoref = useRef(null);
  const [recruiterInfo, setRecruiterInfo] = useState({});
  const userId = currentTestData?.userId || null;
  const [totalTestTime, setTotalTestTime] = useState(0);
  const [isSafariBrowser, setIsSafariBrowser] = useState(false);
  const [vetJdData, setVetJdData] = useState(null);
  const [isCreating, setIsCreating] = useState(false);

  const testBlocks = [
    { icon: <ReadAloudIcon />, title: 'Read Aloud' },
    { icon: <RepeatIcon />, title: 'Repeat Sentence' },
    { icon: <ChatIcon />, title: 'Short Answer' },
    { icon: <SentenceIcon />, title: 'Sentence Build' },
    { icon: <VocabularyIcon />, title: 'Vocabulary' },
    { icon: <WritingIcon />, title: 'Writing' },
  ];

  const isSafari = () => {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  };

  useEffect(() => {
    if (isSafari()) {
      setIsSafariBrowser(true);
    }
  }, []);

 const gotoProfile = async () => {
    await userCameraStreamRef.current.getTracks().forEach((track) => {
      track.stop();
    });
    history("/");
  };

  const constraints = {
    audio: true,
    video: { width: { ideal: 1280 }, height: { ideal: 720 } },
  };

  const getInvitedTestInfo = async () => {
    const payload = {
      email: location?.state?.email,
    };
    const info = await getuserinformation(payload);
    setRecruiterInfo(info.data.data[0]);
  };

  const fetchVetJdData = async () => {
    if (!location?.state?.jdId) return;
    try {
      const response = await getvetjdbyid({ jdId: location.state.jdId });
      setVetJdData(response?.data?.data || null);
    } catch (error) {
      NotificationManager.error('Failed to fetch job description details', 'Error', 5000);
    }
  };

  useEffect(() => {
    return () => {
      if (history.action === "POP") {
        gotoProfile();
      }
    };
  }, [history]);




  useEffect(() => {
    const testId = location?.state?.test?.id || null;
    if (testId) {
      (async () => {
        setisDataLoaded(false);
        const res = await userTestQuestionInfo(testId);

        if (res.data.data) {
          const testIds = res.data.data.map((item) => item.id);
          const totaltime = res.data.data.reduce((accumulator, object) => {
            return accumulator + object.timeLimit * 1;
          }, 0);
          setisDataLoaded(true);
          const timeVal = toHoursAndMinutes(totaltime);
          setTotalTestTime(timeVal);
          setAllTestId(testIds);
        } else {
          setisDataLoaded(true);
          setTotalTestTime(0);
          setAllTestId([]);
        }
      })();
    } else {
      setisDataLoaded(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const opencamera = async () => {
    const videoElement = document.getElementById("video");
    const thumbnailElement = document.getElementById("thumbnail");
    if (!videoElement || !thumbnailElement) {
      return;
    }
    
    videoElement.style.display = "none";

    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      window.stream = stream;
      videoElement.style.display = "block";
      videoref.current.srcObject = stream;
      userCameraStreamRef.current = stream;
      thumbnailElement.style.display = "none";

      const audioContext = new AudioContext();
      const analyser = audioContext.createAnalyser();
      const microphone = audioContext.createMediaStreamSource(stream);
      const scriptProcessor = audioContext.createScriptProcessor(2048, 1, 1);

      analyser.smoothingTimeConstant = 0.8;
      analyser.fftSize = 1024;

      microphone.connect(analyser);
      analyser.connect(scriptProcessor);
      scriptProcessor.connect(audioContext.destination);
      scriptProcessor.onaudioprocess = function () {
        const array = new Uint8Array(analyser.frequencyBinCount);
        analyser.getByteFrequencyData(array);
        const arraySum = array.reduce((a, value) => a + value, 0);
        const average = arraySum / array.length;
        setvolume(average);
      };
    } catch (e) {
      console.log(e);
      if (videoElement) {
        videoElement.style.display = "none";
      }
      userCameraStreamRef.current = "";
    }
  };

  const openSupportModal = () => {
    setIsModelOpen(true);
  };

  const modalClose = () => {
    setIsModelOpen(false);
  };
   const formatDuration = (totalSeconds) => {
      if (!totalSeconds || isNaN(totalSeconds)) return '0 min 0 sec';
      const mins = Math.floor(totalSeconds / 60);
      const secs = totalSeconds % 60;
      return `${mins} min ${secs} sec`;
    };

  const startTest = async () => {
  if (isSafariBrowser) {
    NotificationManager.error(
      "The current version of Safari is not supported. Kindly try Chrome or Edge.",
      "Error",
      10000
    );
    return;
  }

  if (!userCameraStreamRef.current) {
    return NotificationManager.error(
      "This test cannot be taken without activating camera and microphone. Please allow camera and microphone access.",
      "Error",
      10000
    );
  }

  if (userCameraStreamRef.current) {
      await userCameraStreamRef.current.getTracks().forEach((track) => {
        track.stop();
      });
    }

  if (isAiInterviewFlow) {
    history("/startInterview", {
      state: {
        ...location?.state,
        userId,
      },
    });
    return;
  }

  if (isVetFlow) {
    if (!vetJdData) {
      NotificationManager.error('Required data not available', 'Error', 5000);
      return;
    }
    const testId = vetJdData?.tests?.[0]?.id;
    if (!testId) {
      NotificationManager.error('Test ID not found', 'Error', 5000);
      return;
    }
    setIsCreating(true);
    try {
      const normalizedPhoneData = {
        phoneNumber: (location?.state?.phoneNumber || '').toString().trim(),
        countryCode: location?.state?.userLocation?.code || location?.state?.countryCode || '',
        countryCallingCode: (location?.state?.countryCallingCode || location?.state?.userLocation?.dialCode || '').toString().trim()
      };

      const payload = {
        firstName: location?.state?.firstName,
        lastName: location?.state?.lastName,
        email: location?.state?.email ? location.state.email.trim().toLowerCase() : '',
        countryCode: normalizedPhoneData.countryCode,
        countryCallingCode: normalizedPhoneData.countryCallingCode,
        phoneNumber: normalizedPhoneData.phoneNumber,
        testId: testId,
        recruitmentpartnerId: vetJdData?.recruitmentpartnerId,
        resumeId: null,
        isVerified: true,
        testStatusId: null,
        createdBy: vetJdData.createdBy,
        updatedBy: vetJdData.updatedBy,
      };
      const response = await createvetcandidatetest(payload);
      const candidateTestId = response.data.data.id;
      history(`/startInterview?int=vet&ct=${candidateTestId}`, {
        state: {
          isVet: true,
          ...location?.state,
          vetJdData: vetJdData,
          candidateTestData: response.data.data,
        },
      });
    } catch (error) {
      NotificationManager.error(
        error?.response?.data?.message || 'Failed to create test. Please try again.',
        'Error',
        5000
      );
    } finally {
      setIsCreating(false);
    }
    return;
  }

  if (allTestId.length > 0) {
    history("/video-skill-test-registered", {
      state: {
        ...location?.state,
        userId,
        allTestId,
      },
    });
  } else {
    NotificationManager.error(
      "Question Bank For This Skill Is Being Updated – Please Try Later",
      "Error",
      10000
    );
  }
};


  useEffect(() => {
    if (isRegularSkillTestFlow) {
      getInvitedTestInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRegularSkillTestFlow]);

  useEffect(() => {
    if (isVetFlow) {
      fetchVetJdData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (isDataLoaded) {
      opencamera();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDataLoaded]);

  return (
    <>
      {
        isVetFlow && (userType === "Admin" || userType === "Recruiter") ? <UnauthorizedAccess /> : (
          <div className="mainContainer_reg test-landing-page-root">
            <div className="topContainer">
              <div className="nav_bg_home home-specific-header">
                <div className="container w1200 nav_bg_home_section">
                  <div className="nav_bg_left">
                    <li className="cp headerListStyleNone" onClick={gotoProfile}>
                      <span>
                        <img
                          src={recruiter_header_logo}
                          className="nav_logo_home"
                          alt="img"
                        />
                      </span>
                    </li>
                  </div>
                  <div className="nav_bg_right">
                    <ul className="navbar_home">
                      <li className="special_hover cp" onClick={openSupportModal}>
                        <span className="contactUsFont">Contact Us</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {!isDataLoaded ? (
                <TestLandingSkeleton />
              )
                // : showVetTest ? (


                //   <VetTest 

                //     locationData={location.state}
                //     vetJdData={vetJdData}
                //   />
                // ) 
                : (
                  <div className="main_landing_container">
                    <div className="test_landing_header1 pr">
                      <div className="bubble_icon_section">
                        <img src={bubble} alt="logo" />
                      </div>

                      <p className="test_landing_header_text_1">
                        Welcome to ClearedTalent
                      </p>

                      {isVetFlow ? (
                        <p className="test_landing_header_text_2">
                          Start when you are ready
                        </p>
                      ) : (
                        <p className="test_landing_header_text_2">
                          Test for {currentTestData?.testName || "AI Interview"}
                        </p>
                      )

                      }

                      {!isAiInterviewFlow && (
                        <p className="test_landing_header_text_3">
                          <span className="test_landing_header_text_3_3">
                            {recruiterInfo?.user?.firstName
                              ? recruiterInfo?.user?.firstName
                              : ""}{" "}
                            {recruiterInfo?.user?.lastName
                              ? recruiterInfo?.user?.lastName
                              : ""}
                          </span>{" "}
                          {recruiterInfo?.user?.recruitmentpartner?.name
                            ? `(${recruiterInfo?.user?.recruitmentpartner?.name})`
                            : ""}
                        </p>
                      )}
                    </div>
                    <Grid container spacing={0} className="test_landing_main">
                      <Grid
                        size={{ xs: 12, sm: 6 }}
                        className="vl_recruiter test_landing_left_bg"
                      >
                        <div className="form-one-left_recruiter test_left_adjust">
                          <div className="form-one-left-upper test_landing_video_layout">
                            <div className="form-one-left-section df">
                              <video
                                className="MediaStreamView-video test_landing"
                                id="video"
                                playsInline
                                ref={videoref}
                                autoPlay={true}
                              />
                              <img
                                src={DefaultThumbnail}
                                id="thumbnail"
                                className="default_video"
                                alt="img"
                              />
                              <div className="test_landing_video_bottom_section">
                                {userCameraStreamRef.current ? (
                                  <>
                                    <div className="test_landing_video_bottom_icon">
                                      <VidOn />
                                    </div>
                                    <div className="test_landing_video_bottom_icon">
                                      <MicOn fill="#111" />
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div className="test_landing_video_bottom_icon">
                                      <VidOff />
                                    </div>
                                    <div className="test_landing_video_bottom_icon">
                                      <MicOff fill="#111" />
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                            <div className="bar">
                              {isMicOpen ? (
                                <div
                                  className="pid"
                                  style={{ height: `${volume}%` }}
                                ></div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="test_recorder_bottom_text_section">
                          <p className="test_recorder_bottom_text_section_text">
                            *Please allow access to the microphone and camera
                          </p>
                        </div>
                      </Grid>
                      <Grid size={{ xs: 12, sm: 6 }}>
                        <div className="mainbg_form_recruiter df">
                          <div className="other_formpage_recruiter">
                            <div className="form_text_container_other">
                              <div className="test_dres_right_header">
                                <p className="test_dres_right_header_text">
                                  Start when you are ready
                                </p>
                              </div>

                              {isRegularSkillTestFlow || isAiInterviewFlow || isVetFlow ?

                                <div className="form-one-left-text test_screen">

                                  {isVetFlow ? (
                                    <>
                                      <div className="test-blocks-container">
                                        {testBlocks.map((block, index) => (
                                          <div key={index} className="test-block">
                                            <span className="test-icon">{block.icon}</span>
                                            <div className="test-info">
                                              <h3 className="test-title">{block.title}</h3>
                                            </div>
                                          </div>
                                        ))}
                                      </div>
                                      <div className="instructions-section">
                                        <h3 className="instructions-title">Instructions</h3>
                                        <div className="instructions-list">
                                          <p className="instruction-item"><span className="instruction-number">1.</span> The clock starts as soon as you click <strong>"Start Assessment"</strong> so start <strong>ONLY</strong> when you are ready.</p>
                                          <p className="instruction-item"><span className="instruction-number">2.</span> Some questions may have two parts requiring both spoken and written responses.</p>
                                          <p className="instruction-item"><span className="instruction-number">3.</span> You will be video recorded during the test so please ensure your camera is active.</p>
                                          <p className="instruction-item"><span className="instruction-number">4.</span> You cannot go back to previous questions at any point during the test.</p>
                                          <p className="instruction-item"><span className="instruction-number">5.</span> Do not navigate out of the test window. We detect such movements and report them.</p>
                                        </div>
                                      </div>
                                    </>
                                  ) : isAiInterviewFlow ? (
                                    <>
                                      <p className="test_dres_right_header_text_1">
                                        1. You will be video recorded during the interview so please ensure your camera is active and focusing on you.
                                      </p>
                                      <p className="test_dres_right_header_text_1">
                                        2. Please ensure you are in a quiet environment with good lighting and stable internet connection.
                                      </p>
                                      <p className="test_dres_right_header_text_1">
                                        3. Please try not to navigate out of the interview window (or open other applications) for the interview duration. We detect such movements and report them to the reviewer.
                                      </p>
                                      <p className="test_dres_right_header_text_1">
                                        4. This interview will last for approximately {location?.state?.assessmentDurationInSeconds ? formatDuration(location?.state?.assessmentDurationInSeconds) : '0.00 minutes'} .
                                      </p>
                                    </>
                                  ) : (
                                    <>
                                      <p className="test_dres_right_header_text_1">
                                        1. This test has{" "}
                                        <span className="blueTexts">
                                          {" "}
                                          {allTestId.length ? allTestId.length : 0}{" "}
                                        </span>{" "}
                                        multiple choice questions & the total test time
                                        is
                                        <span className="blueTexts">
                                          {totalTestTime.h >= 1
                                            ? ` ${totalTestTime.h}`
                                            : ""}
                                        </span>
                                        {totalTestTime.h > 1
                                          ? " hours,"
                                          : totalTestTime.h === 1
                                            ? " hour,"
                                            : ""}
                                        <span className="blueTexts">
                                          {totalTestTime.m >= 1
                                            ? ` ${totalTestTime.m}`
                                            : ""}
                                        </span>
                                        {totalTestTime.m > 1
                                          ? " minutes"
                                          : totalTestTime.m === 1
                                            ? " minute"
                                            : ""}
                                        {totalTestTime.s >= 1 ? " and" : ""}
                                        <span className="blueTexts">
                                          {totalTestTime.s >= 1
                                            ? ` ${totalTestTime.s}`
                                            : ""}
                                        </span>
                                        {totalTestTime.s > 1
                                          ? " seconds"
                                          : totalTestTime.s === 1
                                            ? " second"
                                            : ""}
                                        <span className="blueTexts">
                                          {allTestId.length === 0 ? ` ${"0"} ` : ""}
                                        </span>
                                        {allTestId.length === 0 ? "minute" : ""}.
                                      </p>
                                      <p className="test_dres_right_header_text_1">
                                        2. For multiple choice questions, you may be
                                        allowed to pick just one answer choice or
                                        multiple. The clock starts as soon as you click{" "}
                                        <span className="leftBullets">
                                          "Start Test"
                                        </span>{" "}
                                        so start{" "}
                                        <span className="leftBullets">ONLY</span> when
                                        you are ready.
                                      </p>
                                      <p className="test_dres_right_header_text_1">
                                        3. Some questions may have two parts. For
                                        example, Part 1 may be an open ended question
                                        where you are expected to speak out your
                                        response on video for 1 minute and Part 2 may be
                                        a multiple choice question where you are
                                        expected to pick the correct answer(s) from the
                                        options provided.
                                      </p>
                                      <p className="test_dres_right_header_text_1">
                                        4. You will be video recorded during the test so
                                        please ensure your camera is active and focusing
                                        on you.
                                      </p>
                                      <p className="test_dres_right_header_text_1">
                                        5. Please note that at no point during the test
                                        you can go back to the previous question.
                                      </p>
                                      <p className="test_dres_right_header_text_1">
                                        6. Please try not to navigate out of the test
                                        window (or open other applications) for the test
                                        duration. We detect such movements and report
                                        them to the reviewer.
                                      </p>
                                    </>
                                  )}
                                </div>
                                : null
                              }

                              <>
                                  <div className="test_dres_right_bottom">
                                    <p className="test_dres_right_bottom_text">
                                      If you're all set click the button below.
                                    </p>
                                  </div>
                                  <div className="test_landing_button_wrapper">
                                    <button
                                      type="button"
                                      className="btn-testlanding btn-test-landing"
                                      onClick={() => startTest()}
                                      disabled={isVetFlow && isCreating}
                                    >
                                      {isVetFlow
                                        ? (isCreating ? 'Creating Test...' : 'Start Assessment')
                                        : isAiInterviewFlow
                                        ? 'Start Interview'
                                        : 'Start Test'}
                                    </button>
                                  </div>

                                  {!isAiInterviewFlow && !isVetFlow && (
                                    <div className="test_dres_right_bottom">
                                      <p className="test_dres_right_bottom_text_2">
                                        {recruiterInfo?.expiresOn
                                          ? ` Test invitation expires on ${recruiterInfo?.expiresOn
                                            .split("-")
                                            .reverse()
                                            .join("/")}`
                                          : ""}
                                      </p>
                                    </div>
                                  )}

                              </>

                            </div>
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                )}

              <HomeContactUsModal modalOpen={isModelOpen} modalClose={modalClose} />
              <Footer />
            </div>
          </div>
        )
      }

    </>
  );
};

export default TestLandingPage;
